











































































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import ApiHelper from 'api-helper';
import Toast from '@common/helpers/toast';
import BasicSelect from '@/components/common/BasicSelect.vue';
import moment from 'moment';
import 'vue2-timepicker/dist/VueTimepicker.css';
import 'vue2-datepicker/index.css';
import DatePicker from 'vue2-datepicker';
import { Roles, formatTime } from '@common/app.config';
import BaseDatePicker from '@/components/common/BaseDatePicker.vue';

@Component({
  components: {
    BasicSelect,
    BaseDatePicker,
    DatePicker,
  },
})
export default class PopupCreateAllShiftForm extends Vue {
  @Prop({ required: true }) readonly currentUser!: any;
  @Prop({ required: true }) readonly doctorOptions!: any[];
  @Prop({ default: () => [] }) days_of_week!: string[];
  @Prop({ required: true }) readonly formCreateAll!: any;
  @Prop({ required: true }) readonly hourRange!: any[];
  @Prop({ required: true }) readonly minutesRangeStartTime!: any[];
  @Prop({ required: true }) readonly minutesRangeEndTime!: any[];
  @Prop({ required: true }) readonly notAfterToday!: (date: Date) => boolean;

  Roles = Roles;
  formatTime: string = formatTime;

  private isCheckStartEndTime: boolean = false;
  private isCreating: boolean = false;

  @Watch('formCreateAll.schedule_type')
  onScheduleTypeChange(newType: string) {
    this.formCreateAll.start_date = '';
    this.formCreateAll.start_time = '';
    this.formCreateAll.end_time = '';
    this.isCheckStartEndTime = false;

    if (newType === 'date_range') {
      this.formCreateAll.days_of_week = [];
      this.formCreateAll.end_date = '';
    } else if (newType === 'weekly_recurring') {
      this.formCreateAll.end_date = '';
      this.formCreateAll.days_of_week = [];
    }
  }

  @Watch('formCreateAll.start_date')
  onStartDateChange(newDate: string) {
    if (!newDate) {
      return;
    }

    const today = moment().format('YYYY-MM-DD');
    const selectedDate = moment(newDate).format('YYYY-MM-DD');

    if (today === selectedDate) {
      const now = moment();
      const minutes = parseInt(now.format('mm'));
      const hour = parseInt(now.format('HH'));

      if (minutes === 0) {
        this.$emit('update:hourRange', this.range(hour, 23));
        this.$emit('update:minutesRangeStartTime', [0, 20, 40]);
        this.$emit('update:minutesRangeEndTime', [0, 20, 40]);
        this.formCreateAll.start_time = `${(`0${hour}`).slice(-2)}:00`;
        this.formCreateAll.end_time = `${(`0${hour}`).slice(-2)}:20`;
      } else if (minutes <= 30) {
        this.$emit('update:hourRange', this.range(hour, 23));
        this.$emit('update:minutesRangeStartTime', [40]);
        this.$emit('update:minutesRangeEndTime', [40]);
        this.formCreateAll.start_time = `${(`0${hour}`).slice(-2)}:40`;
        this.formCreateAll.end_time = `${(`0${hour + 1}`).slice(-2)}:00`;
      } else {
        this.$emit('update:hourRange', this.range(hour + 1, 23));
        this.$emit('update:minutesRangeStartTime', [0, 20, 40]);
        this.$emit('update:minutesRangeEndTime', [0, 20, 40]);
        this.formCreateAll.start_time = `${(`0${hour + 1}`).slice(-2)}:00`;
        this.formCreateAll.end_time = `${(`0${hour + 1}`).slice(-2)}:20`;
      }
    } else {
      this.$emit('update:hourRange', this.range(0, 23));
      this.$emit('update:minutesRangeStartTime', [0, 20, 40]);
      this.$emit('update:minutesRangeEndTime', [0, 20, 40]);
    }

    if (this.formCreateAll.end_date && moment(this.formCreateAll.end_date).isBefore(newDate)) {
      this.formCreateAll.end_date = '';
    }
  }

  range(start: number, end: number): number[] {
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  checkAllShiftSubmit(): boolean {
    if (this.isCreating) {
      return true;
    }

    const { doctor_id, start_time, end_time, schedule_type, start_date, end_date, days_of_week } = this.formCreateAll;

    if (!doctor_id || !start_time || !end_time) {
      return true;
    }

    const startTimeMoment = moment(start_time, 'HH:mm');
    const endTimeMoment = moment(end_time, 'HH:mm');

    if (!startTimeMoment.isValid() || !endTimeMoment.isValid() || !endTimeMoment.isAfter(startTimeMoment)) {
      return true;
    }

    if (schedule_type === 'date_range') {
      if (!start_date || !end_date) {
        return true;
      }

      const startDateMoment = moment(start_date, 'YYYY-MM-DD');
      const endDateMoment = moment(end_date, 'YYYY-MM-DD');

      if (!startDateMoment.isValid() || !endDateMoment.isValid() || endDateMoment.isBefore(startDateMoment)) {
        return true;
      }

      return false;
    }

    if (schedule_type === 'weekly_recurring') {
      if (!start_date || !Array.isArray(days_of_week) || days_of_week.length === 0) {
        return true;
      }

      return false;
    }

    return true;
  }

  disableEndDate(date: Date) {
    if (!this.formCreateAll.start_date) {
      return true;
    }

    const startDate = moment(this.formCreateAll.start_date, 'YYYY-MM-DD');
    const endDate = moment(date);

    return endDate.isBefore(startDate, 'day');
  }

  @Watch('formCreateAll.end_time')
  @Watch('formCreateAll.start_time')
  private updateIsCheckStartEndTime(value) {
    if (this.isCheckStartEndTime || value === '00:00') {
      return;
    }
    this.isCheckStartEndTime = true;
  }

  private cancelCreateAllShift() {
    this.$emit('cancel');
  }

  private async createAllShifts() {
    try {
      const isValid = await (this.$refs.formCreateAllShift as any).validate();
      if (!isValid) {
        return;
      }

      this.isCreating = true;

      const payload: any = {
        doctor_id: this.formCreateAll.doctor_id,
        schedule_type: this.formCreateAll.schedule_type,
        start_date: this.formCreateAll.start_date,
        start_time: this.formCreateAll.start_time,
        end_time: this.formCreateAll.end_time,
      };

      if (this.formCreateAll.schedule_type === 'weekly_recurring') {
        payload.days_of_week = this.formCreateAll.days_of_week;
      } else {
        payload.end_date = this.formCreateAll.end_date;
      }

      await ApiHelper.getApi('DoctorSchedulesApi').createSchedule(payload);
      this.cancelCreateAllShift();
      this.$emit('submit');
      Toast.success('シフトが正常に作成されました');
    } catch (error) {
      if (error.response?.status === 422) {
        (this.$refs.formCreateAllShift as any).setErrors(error.response.data.errors);
      }
      if (error.response?.status === 400) {
        this.cancelCreateAllShift();
        Toast.error(error.response.data.message);
      }
    } finally {
      this.isCreating = false;
    }
  }
}
